import {
  SpwnApiResponse,
  SpwnService,
  SpwnServiceFetchPawBalanceRequest,
} from "@spwn-portal/grpc";
import firebase from "firebase/app";
import { useMemo } from "react";
import useSWR from "swr";

import { useConnectClient } from "../../utility/connectWeb";

export type PawBalanceState = {
  freeValue: number;
  paidValue: number;
  isLoading: boolean;
};

export const FetchPawBalanceKey = "fetchPawBalance";

export const useEmoBalance = () => {
  const auth = firebase.auth();
  const connectClient = useConnectClient(SpwnService);

  const { data, isLoading } = useSWR(
    auth.currentUser?.emailVerified ? FetchPawBalanceKey : null,
    async () => {
      const response = await connectClient.fetchPawBalance(
        new SpwnServiceFetchPawBalanceRequest()
      );

      if (response.status !== SpwnApiResponse.SUCCESS) {
        return {
          status: response.status,
        };
      }

      return {
        status: response.status,
        data: {
          balance: response.data?.balance ? Number(response.data.balance) : 0,
        },
      };
    }
  );

  return useMemo(() => {
    return {
      freeValue: 0,
      paidValue: data?.data?.balance ?? 0,
      isLoading,
    };
  }, [data, isLoading]);
};
